var isProduction = process.env.NODE_ENV === 'production';
function warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }

    var text = "Warning: " + message;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {}
  }
}

export default warning;



//////////////////
// WEBPACK FOOTER
// ../~/tiny-warning/dist/tiny-warning.esm.js
// module id = 814
// module chunks = 1